import { useEffect, useState, type RefObject } from "react";

import { ModelViewport } from "../viewport/ModelViewport";

export function useModelViewport(host: RefObject<HTMLElement | null>, background: string): ModelViewport | null {
  const [viewport, setViewport] = useState<ModelViewport | null>(null);

  useEffect(() => {
    if (!host.current) return;
    const created = new ModelViewport(host.current, background);
    setViewport(created);
    return () => {
      created.dispose();
      setViewport(null);
    };
  }, [host, background]);

  return viewport;
}
